import React, { Component } from "react";

import Image from "../../../../components/image";
import { getLanguageField } from "../../../../utils/language";
import { strippTags, transformHTMLEntities } from "../../../../utils/string";
import Pricing from "../../../../components/pricing";
import Icon from "../../../../components/icon/icon";
import { toCurrency } from "src/utils/currency";

export default class LogingCell extends Component {
  render() {
    const { unit, index, onCtaClick, ctaText, buttonStyle, language, stayOptions = {}, removeFrom = false, isHotel, disabled, disabledText, isPackage, displayedLabel } = this.props;
    const description = strippTags(getLanguageField(unit.translations, language, isPackage ? "short_description" : "description"))
    const descriptionWithoutEntities = transformHTMLEntities(description);
    const selectedServices = [];
    if (unit && unit.selectedServices && unit.selectedServices.length) {
      unit.selectedServices.forEach((service) => {
        const groupName = getLanguageField(service.translations, language, "group_name");
        const individualName = getLanguageField(service.translations, language, "name");
        const serviceName = unit.selectedServices.filter(serv => 
          getLanguageField(serv.translations, language, "group_name") === groupName && groupName.length).length > 1 
          ? groupName 
          : individualName;
          
        if (!selectedServices.find(serv => serv.serviceName === serviceName)) {
          selectedServices.push({ ...service, serviceName });
        }
      });
    }

    let imageSrc = '';
    if (unit.images) {
      if (unit.images[0] && unit.images[0].image) {
        imageSrc = `https://public-assets.spotliodata.com/${unit.images[0]?.image.filename_disk}`;
      } else {
        imageSrc = `https://public-assets.spotliodata.com/${unit.images[0]?.directus_files_id?.filename_disk}`;
      }
    }
    const name = isHotel ? getLanguageField(unit.translations, language, "name") : unit.name;

    return (
      <div
        onClick={() => onCtaClick(index)}
        onKeyDown={onCtaClick ? (e) => e.key === 'Enter' && onCtaClick(index) : null}
        tabIndex={0} // Ensure tabIndex is only present when the element is interactive
        key={unit.id}
        className="flex"
      >
        {
          unit.images ?
            <div className="flex-shrink-0">
              <Image className={"w-44 h-36 rounded-2xl sm:rounded-2xl overflow-hidden sm:w-60 object-cover"} alt={unit.name} src={imageSrc} />
            </div>
            : null
        }
        <div className="ml-3 flex-1 flex flex-col lg:ml-4 justify-between lg:flex-row">
          <div className="lg:w-3/4 flex flex-col gap-1">
            <h4 className="text-lg font-bold">
              {name}
            </h4>
            {stayOptions.book_from && stayOptions.book_to ?
              <div className="flex gap-1 text-sm text-gray-500">
                {`${stayOptions.book_from} - `}
                {stayOptions.book_to}
              </div>
              : null
            }
            <div className="flex gap-1">
              {unit.discount ? <div className="bg-[#E9F4E8] text-[#098A00] text-sm font-bold rounded-2xl py-1 px-2">up to -20%</div> : null}
              {unit.breakfast ? <div className="bg-[#FCF0E0] text-[#E87E00] text-sm font-bold rounded-2xl py-1 px-2">Breakfast</div> : null}
            </div>
            <p className="hidden lg:line-clamp-3 text-sm text-gray-500">
              {descriptionWithoutEntities}
            </p>
            {
              selectedServices && selectedServices.length ?
              <React.Fragment>
                <span className="text-sm italic">{displayedLabel}</span>
                <div className="flex gap-2 flex-wrap items-center">
                  {selectedServices.map((s, idx) => {
                    return <React.Fragment key={`selected-service-${idx}`}>
                      <Icon icon="Check" className="w-4 h-4" />
                      <div key={`selected-service-${idx}`} className="text-sm">{s.serviceName}</div>
                      {s.show_price ? <span>(+{toCurrency({ value: s.price.price_value, valueCurrency: s.price.currency })})</span> : null}
                    </React.Fragment>
                  })}
                </div>
              </React.Fragment>
                
                : null
            }
          </div>
          <div className="lg:w-1/4 flex flex-col justify-between items-end">
            <Pricing pricingType={unit.pricingType} price={unit.price ? unit.price[0] : false} removeFrom={removeFrom} language={language} />
            { disabled && disabledText ? <span className="ml-auto text-sm text-gray-500 text-left sm:text-end">{disabledText}</span> : null}
            {
              ctaText && onCtaClick ?
                <button
                  onClick={() => onCtaClick(index)}
                  className={`text-sm hidden lg:flex items-center gap-1 border py-2 px-3 rounded uppercase mt-auto ml-auto ${buttonStyle}`}
                >
                  <span>{ctaText}</span>
                </button>
                : null
            }
          </div>
        </div>
      </div>
    )
  }
}

